(function ($) {
  function updateSignpostingForm() {
    let signpostingForm = $(".signposting-form");
    if (signpostingForm.length == 0) return;

    let selectedGroup = signpostingForm.find("#selected-group option:selected");
    let optionId = selectedGroup.data("option-id");
    let allOptions = signpostingForm.find("#selected-page option");
    let hasSelectedOption = false;

    allOptions.each(function () {
      const optionGroup = $(this).data("group");
      if (optionGroup === optionId) {
        $(this).show();
        if (!hasSelectedOption) {
          $(this).prop("selected", true);
          hasSelectedOption = true;
        }
      } else {
        $(this).hide();
      }
    });
  }

  $(document).on("change", ".signposting-form #selected-group", function () {
    updateSignpostingForm();
  });

  updateSignpostingForm();

  $(document).on("submit", ".signposting-form", function (e) {
    e.preventDefault();

    let selectedPage = $(this).find("#selected-page option:selected");
    let selectedGroup = $(this).find("#selected-group option:selected");

    // Tracking for Google Analytics
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "signposting_submit",
      group: selectedGroup.text(),
      link: selectedPage.text(),
    });

    if (selectedPage.val()) {
      window.location.href = selectedPage.val();
    }
  });
})(jQuery);
